/* One canonical variant and one native cart form drive both add buttons. */
document.querySelectorAll('[data-product]').forEach(root => {
  const select = root.querySelector('[data-variant-select]');
  const form = root.querySelector('[data-purchase-form]');
  const data = root.querySelector('[data-variants]');
  if (!select || !form || !data) return;
  let variants;
  try { variants = JSON.parse(data.textContent); } catch { return; }
  if (!Array.isArray(variants) || !variants.length || variants.some(v => !v.id || !Array.isArray(v.options))) return;
  const radios = [...root.querySelectorAll('[data-option-radio]')];
  const buttons = [...root.querySelectorAll('[data-add-button]')];
  const thumbnails = [...root.querySelectorAll('[data-gallery-thumbnail]')];
  const stickySelectors = [...root.querySelectorAll('[data-sticky-option]')];
  const stickyImage = root.querySelector('[data-sticky-image]');
  const galleryStage = root.querySelector('[data-gallery-stage]');
  const galleryCount = root.querySelector('[data-gallery-count]');
  const previousPhoto = root.querySelector('[data-gallery-prev]');
  const nextPhoto = root.querySelector('[data-gallery-next]');
  const colorIndex = Number(root.dataset.colorIndex);
  const pending = root.dataset.setupPending === 'true';
  const image = root.querySelector('[data-main-image]');
  let selected = variants.find(v => String(v.id) === select.value) || variants[0];
  let choices = [...selected.options];
  let galleryColor;
  let currentPhoto;
  const setImage = (src, alt) => {
    if (!image || !src) return;
    image.src = src; image.removeAttribute('srcset'); image.alt = alt || '';
    currentPhoto = src;
    thumbnails.forEach(link => {
      if (link.dataset.imageUrl === src) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    const visible = thumbnails.filter(link => !link.hidden);
    const index = visible.findIndex(link => link.dataset.imageUrl === src);
    if (galleryCount) galleryCount.textContent = index >= 0 ? `${index + 1} / ${visible.length}` : '';
    [previousPhoto, nextPhoto].forEach(button => { if (button) button.disabled = visible.length < 2; });
  };
  const movePhoto = direction => {
    const visible = thumbnails.filter(link => !link.hidden);
    if (visible.length < 2) return;
    const index = Math.max(0, visible.findIndex(link => link.dataset.imageUrl === currentPhoto));
    const photo = visible[(index + direction + visible.length) % visible.length];
    setImage(photo.dataset.imageUrl, photo.dataset.imageAlt);
  };
  const render = (variant, updateUrl = false) => {
    const available = Boolean(variant?.available) && !pending;
    const action = pending ? 'Coming soon' : !variant ? 'Unavailable combination' : available ? 'Add to cart' : 'Sold out';
    form.elements.id.value = variant?.id || '';
    buttons.forEach(button => { button.disabled = !available; button.textContent = action; });
    root.querySelector('[data-availability]').textContent = pending ? 'Coming soon' : !variant ? 'This colour and size combination is unavailable' : available ? 'Available' : 'Sold out';
    if (variant) {
      selected = variant; select.value = String(variant.id);
      root.querySelectorAll('[data-price]').forEach(node => { node.textContent = variant.price; });
    }
    const sticky = root.querySelector('[data-sticky-options]');
    if (sticky) sticky.textContent = choices.join(' / ');
    stickySelectors.forEach(control => { control.value = choices[Number(control.dataset.optionIndex)] || ''; });
    radios.forEach(radio => {
      const index = Number(radio.dataset.optionIndex);
      radio.checked = choices[index] === radio.value;
      const combination = choices.map((value, i) => i === index ? radio.value : value);
      const match = variants.find(v => v.options.every((value, i) => value === combination[i]));
      radio.closest('label')?.classList.toggle('is-unavailable', !match?.available);
    });
    root.querySelectorAll('[data-option-value]').forEach(node => { node.textContent = choices[Number(node.dataset.optionValue)] || ''; });
    const color = colorIndex >= 0 ? choices[colorIndex] : '';
    root.querySelectorAll('[data-gallery-thumbnail], [data-product-detail]').forEach(node => { node.hidden = Boolean(node.dataset.color && color && node.dataset.color !== color); });
    const firstPhoto = thumbnails.find(link => !link.hidden);
    if (galleryColor !== color) {
      setImage(variant?.image || firstPhoto?.dataset.imageUrl, variant?.imageAlt || firstPhoto?.dataset.imageAlt);
      galleryColor = color;
    }
    const closePhoto = [...root.querySelectorAll('[data-pants-thumbnail]')].find(link => !link.hidden) || firstPhoto;
    if (stickyImage && closePhoto) {
      stickyImage.src = closePhoto.dataset.stickyImageUrl || closePhoto.dataset.imageUrl;
      stickyImage.removeAttribute('srcset');
      stickyImage.alt = `${color || 'Blue Label'} jeans, pants close-up`;
    }
    if (updateUrl && variant) {
      const url = new URL(location.href); url.searchParams.set('variant', variant.id);
      if (url.href !== location.href) history.pushState({}, '', url);
    }
  };
  select.addEventListener('change', () => {
    const variant = variants.find(v => String(v.id) === select.value);
    if (!variant) return;
    choices = [...variant.options]; render(variant, true);
  });
  radios.forEach(radio => radio.addEventListener('change', () => {
    choices[Number(radio.dataset.optionIndex)] = radio.value;
    render(variants.find(v => v.options.every((value, index) => value === choices[index])), true);
  }));
  stickySelectors.forEach(control => control.addEventListener('change', () => {
    choices[Number(control.dataset.optionIndex)] = control.value;
    render(variants.find(v => v.options.every((value, index) => value === choices[index])), true);
  }));
  thumbnails.forEach(link => link.addEventListener('click', event => {
    event.preventDefault(); setImage(link.dataset.imageUrl, link.dataset.imageAlt);
  }));
  previousPhoto?.addEventListener('click', () => movePhoto(-1));
  nextPhoto?.addEventListener('click', () => movePhoto(1));
  if (galleryStage && image && thumbnails.length) {
    let start;
    galleryStage.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault(); movePhoto(event.key === 'ArrowRight' ? 1 : -1);
    });
    galleryStage.addEventListener('pointerdown', event => {
      if (event.isPrimary === false || (event.button !== undefined && event.button !== 0) || event.target?.closest?.('button, a')) return;
      start = {x:event.clientX, y:event.clientY, id:event.pointerId};
      galleryStage.setPointerCapture?.(event.pointerId);
    });
    galleryStage.addEventListener('pointerup', event => {
      if (!start || event.pointerId !== start.id) return;
      const dx = event.clientX - start.x, dy = event.clientY - start.y;
      start = undefined;
      if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.3) movePhoto(dx < 0 ? 1 : -1);
    });
    galleryStage.addEventListener('pointercancel', () => { start = undefined; });
    root.querySelector('[data-gallery-controls]')?.removeAttribute('hidden');
  }
  window.addEventListener('popstate', () => {
    const id = new URL(location.href).searchParams.get('variant');
    const variant = variants.find(v => String(v.id) === id) || variants[0];
    choices = [...variant.options]; render(variant);
  });
  root.querySelector('[data-enhanced-options]')?.removeAttribute('hidden');
  root.querySelector('[data-sticky-controls]')?.removeAttribute('hidden');
  root.querySelector('[data-native-options]')?.setAttribute('hidden', '');
  root.querySelector('[data-select-variant]')?.setAttribute('hidden', '');
  render(selected);
});
